import React from "react"
import { Form as GoodForm } from "react-good-form"
import { Async, Operation, Variable } from "react-declarative-state"
import { FormGroup, Button, Container, Row, Col } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { requestPasswordResetLink } from "../services/userService"
import { emailRegex } from "../utility/userHelpers"
import { toast } from "../portals/toast"

const RequestPasswordLink: React.FC = () => {
  const navigate = useNavigate()
  return (
    <Container>
      <Row>
        <Col xs={12} md={{ span: 6, offset: 3 }}>
          <Variable initialValue={{ email: "", requestSent: false } as { email: string; requestSent: boolean }}>
            {(passwordReset, setPasswordReset) =>
              passwordReset.requestSent ? (
                <>
                  <div className="d-flex flex-column">
                    <h3 className="mb-3">Lähetetty onnistuneesti!</h3>
                    <div className="mb-3">
                      Lähetimme linkin salasanan uusimista varten sähköpostiisi. Linkki on käytössä seuraavat 24 tuntia.
                    </div>
                    <Button onClick={() => navigate("/")}>Takaisin etusivulle</Button>
                  </div>
                </>
              ) : (
                <Operation
                  onDone={() => {
                    console.log("DONE")
                    setPasswordReset({ ...passwordReset, requestSent: true })
                  }}
                >
                  {(doOperation, progress) => (
                    <GoodForm
                      value={passwordReset}
                      onChange={setPasswordReset}
                      customErrorMessages={{ regExp: { email: "Kirjoita sähköposti muodossa: malli@huolla.com" } }}
                      onSubmit={() => {
                        console.log("Submit")
                        doOperation(
                          requestPasswordResetLink(passwordReset.email).do(
                            () => {},
                            (err) => {
                              console.log(err)
                              toast("Jokin meni pieleen. Yritä uudelleen.", "danger")
                            }
                          )
                        )
                      }}
                    >
                      {({ Input }) => (
                        <>
                          <div className="d-flex flex-column">
                            <h3 className="mb-3">Unohditko salasanasi?</h3>
                            <div className="mb-3">
                              Anna sähköpostiosoitteesi, jota olet käyttänyt tilin luomiseen. Lähetämme sinulle linkin
                              salasanan vaihtamista varten.
                            </div>
                            <FormGroup className="mb-4">
                              <Input
                                type="email"
                                for="email"
                                placeholder="email@huolla.com"
                                required
                                className="form-control"
                                regExp={emailRegex}
                              ></Input>
                            </FormGroup>
                            <div className="mb-4">
                              <Button
                                disabled={progress === Async.Progress.Progressing}
                                className="form-control"
                                type="submit"
                                variant="primary"
                              >
                                Lähetä linkki
                              </Button>
                            </div>
                          </div>
                        </>
                      )}
                    </GoodForm>
                  )}
                </Operation>
              )
            }
          </Variable>
        </Col>
      </Row>
    </Container>
  )
}

export default RequestPasswordLink
